import { Component, output } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { TranslocoModule } from '@jsverse/transloco'
import { TbButtonComponent } from '@components-library/tb-button/tb-button.component'

@Component({
    selector: 'app-filter-no-results',
    templateUrl: './filter-no-results.component.html',
    imports: [TranslocoModule, MatIconModule, TbButtonComponent],
})
export class FilterNoResultsComponent {
    readonly changeFilters = output<void>()
}
